import { render, staticRenderFns } from "./homepage-hot-drops.vue?vue&type=template&id=1a931c5f&scoped=true&"
import script from "./homepage-hot-drops.vue?vue&type=script&lang=js&"
export * from "./homepage-hot-drops.vue?vue&type=script&lang=js&"
import style0 from "./homepage-hot-drops.vue?vue&type=style&index=0&id=1a931c5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a931c5f",
  null
  
)

export default component.exports